const RoomActionTypes = {
  SET_ROOM_DATA: "SET_ROOM_DATA",
  SET_ROOM_DATA_IN_WATCH_VIDEO: "ROOMS_SET_ROOM_DATA_IN_WATCH_VIDEO",
  RESET: "ROOMS_RESET",
  SET_LOADING_ROOM_DATA: "SET_LOADING_ROOM_DATA"
};

export default RoomActionTypes;
